import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import useCustomNavigate from '../../../hooks/useCustomNavigate';

function PropertiesHeaderSection({ headerTitle = "Popular Owner Properties", buttonText = "See all Properties", navigateTo = "/allproperties/jaipur" }) {


  const { goToNewTab } = useCustomNavigate()

  return (
    <div className="flex items-center justify-between py-4 px-8">
      <div>
        <h2 className="text-[24px] font-normal text-[#303030]">{headerTitle}</h2>
        <div className="w-8 h-1 bg-yellow-400 mt-1"></div>
      </div>
      <button

        onClick={() => {goToNewTab(navigateTo) }}

        className="text-[#D8232A] hover:text-red-600 flex items-center font-semibold transition duration-300 group">
        {buttonText}
        <MdArrowForward className="ml-1 transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </div>
  );
}

export default PropertiesHeaderSection;
